"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hooks = require("./hooks");

require("./IconToast.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var IconToast = function IconToast(_ref) {
  var icon = _ref.icon,
      iconColor = _ref.iconColor,
      title = _ref.title,
      message = _ref.message,
      color = _ref.color,
      btnComponent = _ref.btnComponent,
      onDismiss = _ref.onDismiss,
      onClose = _ref.onClose,
      timeout = _ref.timeout;

  var _useOpenAndDismiss = (0, _hooks.useOpenAndDismiss)(onClose, onDismiss, timeout),
      _useOpenAndDismiss2 = _slicedToArray(_useOpenAndDismiss, 2),
      isOpen = _useOpenAndDismiss2[0],
      dismissToast = _useOpenAndDismiss2[1];

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'gcl-icon-toast-wrapper' + (isOpen ? ' open' : '')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'gcl-icon-toast' + (title == null ? ' no-title' : '')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-toast-color ".concat(color)
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'gcl-toast-icon ' + iconColor
  }, icon && /*#__PURE__*/_react["default"].createElement("i", {
    className: 'gcl-icon ' + icon
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-toast-body"
  }, title && /*#__PURE__*/_react["default"].createElement("p", {
    className: "gcl-toast-title"
  }, title), /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-toast-msg"
  }, message)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-toast-btn"
  }, /*#__PURE__*/_react["default"].cloneElement(btnComponent, {
    onClick: dismissToast
  }))));
};

IconToast.propTypes = {
  icon: _propTypes["default"].string,
  title: _propTypes["default"].string,
  message: _propTypes["default"].string.isRequired,
  btnComponent: _propTypes["default"].element.isRequired,
  onDismiss: _propTypes["default"].func,
  onClose: _propTypes["default"].func,
  timeout: _propTypes["default"].number,
  color: _propTypes["default"].oneOf(['blue', 'red', 'green', 'yellow']),
  iconColor: _propTypes["default"].oneOf(['blue', 'red', 'green', 'yellow'])
};
IconToast.defaultProps = {
  color: 'blue',
  timeout: 7500
};
var _default = IconToast;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/global-components-library/dist/components/Toasts/IconToast.js
// module id = 1931
// module chunks = 0